import { render, staticRenderFns } from "./pastTag.vue?vue&type=template&id=7999f5a1&scoped=true&"
import script from "./pastTag.vue?vue&type=script&lang=js&"
export * from "./pastTag.vue?vue&type=script&lang=js&"
import style0 from "./pastTag.vue?vue&type=style&index=0&id=7999f5a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7999f5a1",
  null
  
)

export default component.exports